// extracted by mini-css-extract-plugin
export default {"user-actions-widget-container":"UserActionsWidget_user-actions-widget-container__7KcGJ","message-btn":"UserActionsWidget_message-btn__7LBmG"};